require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-kristin-smith.json") })
        }
      }, "path---blog-author-kristin-smith");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-kristin-smith!./.cache/json/blog-author-kristin-smith.json
// module id = 669
// module chunks = 231608221292675